package event

import csstype.Properties
import emotion.css.keyframes
import emotion.react.css
import helpers.isPhone
import js.lazy.Lazy
import js.objects.Record
import js.objects.jso
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.svg.ReactSVG
import ru.malygin.helpers.moreAndLessThem
import ru.malygin.helpers.roundMy
import utils.logger.log
import web.cssom.*
import kotlin.random.Random


external interface SnowProps: Props{
    var ide: Int
}

class Snow {

    @Lazy
    val snowFall = FC {
        val phone = isPhone()

        log.i("[${this@Snow::class}] isPhone: $phone")

        val maxElements = if(phone) 40 else 200

        ReactHTML.div{
            className = ClassName("snow_fall")

            (1..maxElements).forEach {
                snow{
                    this.ide = it
                }
            }
        }

    }

    private val snow = FC<SnowProps> {props ->// анимация и размеры должны задаватся через код

        val opacityR = Random.nextDouble(
            from = 0.3001,
            until = 0.9999
        ).roundMy()

        val trX = createInitialX()

        ReactHTML.span{
            className = ClassName("snow")

            css(this.className){
                nthChild(
                    selector = "${props.ide}"
                ){
                    opacity = number(opacityR)
                    transform = createTransform(trX)
                    animation = createAnimation(trX)
                }

            }

//            +"❄\uFE0F"//"❄\uFE0F"
            ReactSVG.svg{
                this.fill = "aqua"

                this.xmlns = "http://www.w3.org/2000/svg"
                this.height = 24.0
                this.width= 24.0
                this.viewBox = "0 -960 960 960"
                ReactSVG.path{
                    this.d="M440-80v-166L310-118l-56-56 186-186v-80h-80L174-254l-56-56 128-130H80v-80h166L118-650l56-56 186 186h80v-80L254-786l56-56 130 128v-166h80v166l130-128 56 56-186 186v80h80l186-186 56 56-128 130h166v80H714l128 130-56 56-186-186h-80v80l186 186-56 56-130-128v166h-80Z"
                }
            }
//            AcUnitIcon.icon()
        }
    }

    /**
     * Создание случайного значения для X кординаты
     */
    private fun createInitialX(

    ):Double{
        val transform_translateFirst = Random.nextDouble(
            from = 0.011,
            until = 98.221
        ).roundMy()

        return transform_translateFirst
    }

    /**
     * Создание стартовой позиции
     */
    private fun createTransform(
        xPosition: Double
    ): Transform{
        val transform_translateFirst = xPosition

        val transform_scale = Random.nextDouble(
            from = 0.2001,
            until = 1.0
        ).roundMy()

        val transform_rotate = Random.nextInt(
            from = 0,
            until = 360
        ).deg

        val tr = array(
            translate(
                tx = transform_translateFirst.vw,
                ty = (-20).px
            ),
            scale(transform_scale),
            rotate(transform_rotate)
        )

        return tr
    }

    /**
     * Создание анимации
     */
    private fun createAnimation(
        xPosition: Double
    ):Animation{
        val isPhone = isPhone()

        val startAnimationPercentageR = Random.nextDouble(
            from = 35.001,
            until = 87.001
        ).pct

        val anim_translateFirstR = Random.nextDouble(
            from = 0.3001,
            until = 5.3001
        ).roundMy()

        val anim_translateFirst2R = Random.nextDouble(
            from = 0.3001,
            until = 5.3001
        ).roundMy()

        val newFirstPositionX = if (Random.nextBoolean()){
            xPosition + anim_translateFirstR
        }else{
            xPosition - anim_translateFirstR
        }.moreAndLessThem(
            max = if (!isPhone) 96.0 else 88.0,
            min = if (!isPhone) 2.0 else 4.0
        )

        val newLastPositionX = if (Random.nextBoolean()){
            xPosition + anim_translateFirst2R
        }else{
            xPosition - anim_translateFirst2R
        }.moreAndLessThem(
            max = if (!isPhone) 96.0 else 88.0,
            min = if (!isPhone) 2.0 else 4.0
        )



        val anim_translateLastR = Random.nextDouble(
            from = 20.001,
            until = 85.000
        ).roundMy()

        val anim_rotateR = Random.nextInt(
            from = 0,
            until = 360
        ).deg

        val anim_scaleR = Random.nextDouble(
            from = 0.0011,
            until = 0.9999
        ).roundMy()


        val keyName = keyframes(
            Record<Percentage, Properties>().apply {
                this.set(
                    key = startAnimationPercentageR,
                    value = jso {
                        this.transform = array(
                            translate(newFirstPositionX.vw, anim_translateLastR.vh),
                            scale(anim_scaleR),
                            rotate(anim_rotateR)
                        )
                    }
                )
                this.set(
                    key = 100.pct,
                    value = jso {
                        this.transform = array(
                            translate(newLastPositionX.vw, 95.vh),
                            scale(anim_scaleR),
                            rotate(anim_rotateR)
                        )
                        this.opacity = number(0.0)
                    }
                )
            }
        )

        val duration = Random.nextInt(
            from = 15,
            until = 55
        )
        val delay = Random.nextInt(
            from = 1,
            until = 21
        )

        val exitAnimation: Animation = array(
            keyName,
            string("${duration}s"),
            string("linear"),
            string("-${delay}s"),
            string("infinite")
        ).unsafeCast<Animation>()

        return exitAnimation
    }

}